export default [
	// {
	// 	path: "/booking",
	// 	exact: true,
	// 	ssr: false,
	// 	component: "Booking",
	// 	mui: true,
	// },
];
